import React from "react";
import { Building2, Store, Waves, TrendingUp } from "lucide-react";
import { useLang } from "../i18n/LanguageContext";
import { Reveal, SectionHeading } from "./Reveal";
import { ABOUT_IMAGE } from "../data/media";

const ICONS = [Building2, Store, Waves, TrendingUp];

export const About = () => {
  const { t } = useLang();

  return (
    <section id="about" className="relative py-24 md:py-32 bg-[#0A0A0A]" data-testid="about-section">
      <div className="px-6 md:px-12 lg:px-20">
        <div className="grid lg:grid-cols-2 gap-14 lg:gap-20 items-start">
          <div>
            <SectionHeading overline={t.about.overline} title={t.about.title} text={t.about.text} />
          </div>
          <Reveal delay={0.1}>
            <div className="relative">
              <div className="aspect-[4/5] overflow-hidden border border-[#2E2E2E]">
                <img src={ABOUT_IMAGE} alt="Phantom Residence architecture" className="w-full h-full object-cover" />
              </div>
              <div className="absolute -bottom-6 -start-6 hidden sm:block border border-[#D4AF37] bg-[#0A0A0A] px-6 py-4">
                <p className="font-serif text-3xl text-[#D4AF37]">170.000 m²</p>
                <p className="text-xs uppercase tracking-[0.18em] text-[#FFFFF0]/60 mt-1">
                  {t.features.general[1].label}
                </p>
              </div>
            </div>
          </Reveal>
        </div>

        <div className="mt-20 grid sm:grid-cols-2 lg:grid-cols-4 gap-4">
          {t.about.cards.map((card, i) => {
            const Icon = ICONS[i];
            return (
              <Reveal key={i} delay={0.08 * i}>
                <div
                  className="group h-full bg-[#141414] border border-[#2E2E2E] p-7 transition-colors duration-500 hover:border-[#D4AF37]/50"
                  data-testid={`about-card-${i}`}
                >
                  <Icon size={28} strokeWidth={1} className="text-[#D4AF37]" />
                  <h3 className="mt-5 font-serif text-2xl font-light text-[#FFFFF0]">{card.title}</h3>
                  <p className="mt-3 text-sm leading-relaxed text-[#FFFFF0]/60 font-light">{card.text}</p>
                </div>
              </Reveal>
            );
          })}
        </div>
      </div>
    </section>
  );
};
